import { LoadingOutlined } from "@ant-design/icons";

export const LoadingPreviewBackground = () => {
  return (
    <div className="width relative flex h-16 w-[250px] items-center justify-center bg-slate-400 font-bold text-white">
      <LoadingOutlined />
    </div>
  );
};
